import React, { useCallback, useEffect, useState, useReducer, useRef } from 'react';
import ReactDOM from 'react-dom';
import Chat from './Chat';
import './ChatThread.css';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import TabsThreadChat from './TabsThreadChat';
import { getListChatThreadByTicket } from '@/service/chatThreadService';
import LoadingPanel from '@/component/common/LoadingPanel';
import { getChatPostListByChatThreadId } from '@/service/chatPostService';
import {
    addChatPostToList,
    deleteChatPostToList,
    updateChatPostToList,
} from '@/component/chatThread/handler/ChatPostHandler';
import ErrorModal from '@/component/common/modal/ErrorModal';
import {
    getTheadCustomerText,
    getUserListCanMention,
    groupThreadChatByType,
} from '@/component/chatThread/handler/ChatThreadHandler';
import { unsubscribeAll } from './handler/SubsciptionHandler';
import { getTicketById } from '@/service/ticketService';
import { useRecoilValue, useRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { multiPanelAtom, reloadChatThreadPanelAtom } from '@/state/atom/panelAtom';
import { isExChangeTicket } from '@/state/ticketState';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { DialogSendChatPostFail } from './messageDialog/DialogSendChatPostFail';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { v4 as uuidv4} from 'uuid';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import { getFormById } from '@/service/formManagementService';
import { getCorporationById } from '@/service/organizationService';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ChatThread(props) {
    useTranslationSubscription();
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    // common project inuse detail state
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);

    // common userDetail state
    const [userDetail, setUserDetail] = useRecoilState(userAtom);

    const listProjectInCorp = useRecoilValue(projectListInCorporationAtom);

    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    const [reload, setReload] = useRecoilState(reloadChatThreadPanelAtom);
    const [exChangeTicket, setExchangeTicket] = useRecoilState(isExChangeTicket);

    const [isLoading, setIsLoading] = useState(false);

    const ticketIdSelected = props?.ticketId;

    const [customerReferenceThread, setCustomerReferenceThread] = useState({});
    const [customerThread, setCustomerThread] = useState({});
    const [internalThread, setInternalThread] = useState({});
    const [aiAssistantThread, setAiAssistantThread] = useState({});
    const [escalationThread, setEscalationThread] = useState([]);
    const [delegateThread, setDelegateThread] = useState({});

    const [isTargetProjectOfTicket, setIsTargetProjectOfTicket] = useState(false);
    let corporationId = corporationDetail.id;
    let projectId = localStorageUtil.getSelectedProjectId();
    let userId = localStorageUtil.getUserDetailId();

    const [ticketInfo, setTicketInfo] = useState({});
    const [selectThread, setSelectThread] = useState({});

    const [isShowAllChatPost, setIsShowAllChatPost] = useState(props.isShowAllChatPost);
    const [chatPostAllList, dispatchChatPostAllList] = useReducer(Utils.reducerDataList, []);
    // Bumped only when the post list is reloaded (`isReload`), so the chat scroll state starts over.
    // INITIAL is also used to remove a post (delete / cancel failed send), which must keep the scroll.
    const [scrollResetKey, setScrollResetKey] = useState(0);
    const setChatPostAllList = useCallback(action => {
        if (action?.isReload) {
            setScrollResetKey(key => key + 1);
        }
        dispatchChatPostAllList(action);
    }, []);
    const [userGuestList, setUserGuestList] = useState([]);
    const [subsciptionChatPostUpdateResponse, setSubsciptionChatPostUpdateResponse] = useState({});

    const [userDelegateCreateTicketDetail, setUserDelegateCreateTicketDetail] = useState({});
    const [fileUploadedList, setFileUploadedList] = useState([]);
    const [chatPostUpdate, setChatPostUpdate] = useState({});
    const [fileUploading, setFileUploading] = useState({});
    const [chatPostInsertFail, setChatPostInsertFail] = useState({});
    const [isOpenDialogSendChatPostFail, setIsOpenDialogSendChatPostFail] = useState(false);
    const [isDataChanged, setIsDataChanged] = useState(false);
    const [ticketOriginInfor, setTicketOriginInfor] = useState({});

    const [isModalUploadFileError, setIsModalUploadFileError] = useState(false);

    const [userChatList, setUserChatList] = useState([]);

    const [userListCanMention, setUserListCanMention] = useState([]);
    const [projectIdListForSubscriptionMention, setProjectIdListForSubscriptionMention] = useState([]);

    // const [exclusiveStartKey, setExclusiveStartKey] = useState('');
    const [lastedCountList, setLastedCountList] = useState(0);
    
    const [fromMsg, setFromMsg] = useState(0);

    // move state outer tabChatThread
    const [changeToThread, setChangeToThread] = useState(null);
    const [isOpenConfirmChangeThread, setIsOpenConfirmChangeThread] = useState(false);
    const [threadChatList, setThreadChatList] = useState([]);
    const [listChatInputValues, setListChatInputValues] = useState([]);
    const aiAssistantToggleOverrideByThreadIdRef = useRef(new Map());

    const [ticketParent, setTicketParent] = useState({});
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [formDetail, setFormDetail] = useState({});
    const [formTargetDetail, setFormTargetDetail] = useState({});
    const [viewerChatThreadCorporationDetail, setViewerChatThreadCorporationDetail] = useState(corporationDetail);
    const [focusedMsgId, setFocusedMsgId] = useState(null);
    
    let args = {
        ...props,
        API: props?.API,
        setIsLoading: setIsLoading,
        projectInuseDetail,
        setProjectInuseDetail,
        listProjectInCorp,
        corporationId: corporationId,
        projectId: projectId,
        userDetail: userDetail,
        setUserDetail,
        isProjectManager,
        corporationDetail,
        selectThreadId : props.selectThreadId,
        selectedProjectId: projectId,
        panelList, 
        setPanelList,
        listChatInputValues,
        setListChatInputValues,

        isShowAllChatPost, 
        setIsShowAllChatPost,
        chatPostAllList, 
        setChatPostAllList,
        fileUploadedList, 
        setFileUploadedList,
        customerReferenceThread,
        setCustomerReferenceThread,
        customerThread,
        setCustomerThread,
        internalThread,
        setInternalThread,
        aiAssistantThread,
        setAiAssistantThread,
        escalationThread,
        setEscalationThread,
        delegateThread,
        setDelegateThread,
        selectThread,
        setSelectThread,
        isTargetProjectOfTicket,
        setIsTargetProjectOfTicket,
        ticketInfo,
        setTicketInfo: setTicketInfo,
        ticketOriginInfor,
        setTicketOriginInfor,
        userGuestList,
        setUserGuestList,
        userDelegateCreateTicketDetail,
        setUserDelegateCreateTicketDetail,
        chatPostUpdate, 
        setChatPostUpdate,
        userChatList, 
        setUserChatList,
        userListCanMention, 
        setUserListCanMention,
        projectIdListForSubscriptionMention, 
        setProjectIdListForSubscriptionMention,
        chatPostInsertFail, 
        setChatPostInsertFail,
        isOpenDialogSendChatPostFail, 
        setIsOpenDialogSendChatPostFail,

        // exclusiveStartKey, 
        // setExclusiveStartKey,
        lastedCountList, 
        setLastedCountList,
        fromMsg, 
        setFromMsg,
        changeToThread, 
        setChangeToThread,
        isOpenConfirmChangeThread,
        setIsOpenConfirmChangeThread,
        threadChatList,
        subsciptionChatPostUpdateResponse, 
        setSubsciptionChatPostUpdateResponse,
        aiAssistantToggleOverrideByThreadIdRef,

        ticketParent,
        setTicketParent,

        viewerChatThreadCorporationDetail,
        setViewerChatThreadCorporationDetail
    };
    
    useEffect(() => {
        return () => {
            // unsubscribe all
            unsubscribeAll(props.panelId);
            // TODO: client id must refresh after load browser 
            localStorageUtil.setClientUUId(uuidv4());
            aiAssistantToggleOverrideByThreadIdRef.current.clear();

            // // cleanup function
            // setIsLoading(false);
            // setCustomerReferenceThread({});
            // setCustomerThread({});
            // setInternalThread({});
            // setEscalationThread([]);
            // setDelegateThread({});
            // setIsTargetProjectOfTicket(false);
            // setTicketInfo({});
            // setSelectThread({});
            // setUserGuestList([]);
            // setSubsciptionChatPostUpdateResponse({});
            // setUserDelegateCreateTicketDetail({});
            // setFileUploadedList([]);
            // setChatPostUpdate({});
            // setFileUploading({});
            // setChatPostInsertFail({});
            // setIsOpenDialogSendChatPostFail(false);
            // setIsDataChanged(false);
            // setTicketOriginInfor({});
            // setIsModalUploadFileError(false);
            // setUserChatList([]);
            // setUserListCanMention([]);
            // setProjectIdListForSubscriptionMention([]);
            // setLastedCountList(0);
            // setFromMsg(0);
            // setChangeToThread(null);
            // setIsOpenConfirmChangeThread(false);
            // setThreadChatList([]);
            // setListChatInputValues([]);
            // setTicketParent({});
            // setIsOpenModalReloadPage(false);
        };
    }, []);

    useEffect(() => {
        const controller1 = new AbortController();
        setIsLoading(true);
        if (
            !Utils.isEmptyObject(selectThread) &&
            !Utils.isEmptyObject(ticketInfo) &&
            !Utils.isEmptyObject(ticketOriginInfor && 
            selectThread.ticketId === ticketInfo.id)
        ) {
            getUserListCanMention(args).then(userListMention => {
                userListMention = userListMention.filter(user => {
                    if (user.id === Constant.CHAT_MENTION_ALL.id) return user;
                    return user.active === Constant.ACTIVE_FLAG.ACTIVE
                });
                setUserListCanMention(userListMention);
            })

            const formId = Utils.convertJSONDataToObject(ticketInfo?.formId);
            getFormById(props?.API, formId?.formId).then((formData) => {
                setFormDetail(formData);
            });
        }

        if (
            !Utils.isEmptyObject(selectThread) &&
            !Utils.isEmptyObject(ticketInfo) &&
            !Utils.isEmptyObject(ticketOriginInfor && selectThread.ticketId !== ticketOriginInfor.id)
        ) {
            const formId = Utils.convertJSONDataToObject(ticketOriginInfor?.formId);
            getFormById(props?.API, formId?.formId).then((formData) => {
                setFormTargetDetail(formData);
            });
            const TICKET_TYPES_DONT_NEED__QUERY_CORPORATION_INFO_FOR_SHARE_LINK = [
                Constant.TICKET_TYPE.TASK
            ];
            if (
                !TICKET_TYPES_DONT_NEED__QUERY_CORPORATION_INFO_FOR_SHARE_LINK.includes(
                    ticketInfo?.ticketType
                )
            ) {
                getCorporationById(null, ticketInfo?.affiliationOrganization)
                    .then(corporationDetail => {
                        if (!Utils.isEmptyObject(corporationDetail))
                            setViewerChatThreadCorporationDetail(corporationDetail);
                    })
                    .catch(err => {
                        setViewerChatThreadCorporationDetail({});
                    });
            }
        }
        setIsLoading(false);

        return () => {
            controller1.abort();
        }
    }, [selectThread, ticketInfo, ticketOriginInfor]);

    useEffect(() => {
        const controller2 = new AbortController();
        setIsLoading(true);
        getTicketById(props?.API, ticketIdSelected, true)
            .then(async ticketData => {
                let listThreadData = await getListChatThreadByTicket(
                    props?.API,
                    ticketData,
                    corporationId,
                    projectInuseDetail.id,
                    userId,
                    exChangeTicket,
                    props.panelType
                )
                
                if (!Utils.isEmptyArray(listThreadData)) {
                    const dataThreadChat = await groupThreadChatByType(
                        args,
                        ticketData,
                        listThreadData,
                        props.panelType
                    );


                    await getDataChatPost(dataThreadChat);

                    setIsLoading(false);
                    setExchangeTicket(false);
                } else {
                    setTicketInfo(ticketData);
                    setIsLoading(false);
                    setExchangeTicket(false);
                }
            })
            .catch(err => {
                console.log('uef getTicketById err :>>', err)
                setIsLoading(false);
            });

        return () => {
            controller2.abort();
        }
    }, [reload, props?.triggerReload]);

    useEffect(() => {
        let tabLists = [];
        if (!Utils.isEmptyObject(customerReferenceThread) && Utils.isEmptyString(ticketParent.deletedAt)) {
            tabLists.push({
                label: trI18n('USER07BTN005'),
                data: customerReferenceThread,
                dataCy: 'tab-customer-reference-thread'
            });
        }

        if (!Utils.isEmptyObject(customerThread)) {
            tabLists.push({
                label: getTheadCustomerText(customerThread, ticketOriginInfor),
                data: customerThread,
                dataCy: 'tab-customer-reference-thread'
            });
        }

        if (!Utils.isEmptyObject(internalThread)) {
            tabLists.push({
                label: trI18n('USER07BTN007'),
                data: internalThread,
                dataCy: 'tab-internal-thread'
            });
        }

        if (!Utils.isEmptyObject(aiAssistantThread)) {
            tabLists.push({
                label: aiAssistantThread.projectName || trI18n('AI_ASSISTANT'),
                data: aiAssistantThread,
                dataCy: 'tab-ai-assistant-thread'
            });
        }

        if (!Utils.isEmptyArray(escalationThread)) {
            escalationThread?.map(item =>
                tabLists.push({
                    label: item.projectName,
                    data: item,
                    dataCy: 'tab-escalation-thread'
                })
            );
        }
        let listChatInputValue = tabLists.map(item => {
            return {
                id: item.data.id,
                content:'',
                isCheckDelegatePostMsg: false,
                isPostCreatedAtCurrentTime: true,
                postCreatedAtDateTime: ''
            }
        } )
        setListChatInputValues(listChatInputValue);
        setThreadChatList(tabLists);
    }, [
        customerReferenceThread,
        customerThread,
        internalThread,
        aiAssistantThread,
        escalationThread,
        ticketOriginInfor,
        userDetail.type
    ]);

    const getDataChatPost = async data => {
        let threadIdList = [];
        if (isShowAllChatPost) {
            if (data.customerReferenceThreadResult) {
                threadIdList.push(data.customerReferenceThreadResult.id);
            }
            if (data.customerThreadResult?.id) {
                threadIdList.push(data.customerThreadResult.id);
            }
            if (data.internalThreadResult?.id) {
                threadIdList.push(data.internalThreadResult.id);
            }
            if (data.listEscalationThreadResult && data.listEscalationThreadResult.length > 0) {
                data.listEscalationThreadResult.forEach(element => {
                    threadIdList.push(element.id);
                });
            }
        } else {
            threadIdList.push(data.selectThreadId);
        }

        // Focus from a share link: the backend returns every page up to the focused message in one call.
        const focusMsgId = Utils.takeFocusedMsgId(ticketIdSelected);

        setIsLoading(true);
        // A (re)load always starts from the newest page; fromMsg may be stale from a previous load-more.
        const posts = await getChatPostListByChatThreadId(
            null,
            threadIdList,
            0,
            projectInuseDetail.id,
            focusMsgId
        );
        if (Utils.isEmptyObject(posts)) {
            return;
        }

        // Batch so the list and the focus target land in the same render (no initial scroll before focus).
        ReactDOM.unstable_batchedUpdates(() => {
            setUserChatList(prev => prev.concat(posts.userChatList || []));
            setChatPostAllList({
                type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.INITIAL,
                posts: posts.chatPostAllList || [],
                isReload: true
            });
            setFromMsg(posts.from || 0);
            setLastedCountList(posts.lastBatchCount);
            setFocusedMsgId(posts.isFocusFound ? focusMsgId : null);
        });
    }; 

    useEffect(() => {
        let post = chatPostUpdate;
        if (Utils.isEmptyObject(post)) {
            return;
        }
        if (post.subcriptionType === Constant.SUBSCRIPTION_TYPE.DELETE) {
            deleteChatPostToList(
                post,
                chatPostAllList,
                setChatPostAllList,
                isDataChanged,
                setIsDataChanged
            );
            return;
        }
        if (post.subcriptionType === Constant.SUBSCRIPTION_TYPE.UPDATE) {
            delete post.subcriptionType;
            updateChatPostToList(
                post,
                chatPostAllList,
                setChatPostAllList,
                isDataChanged,
                setIsDataChanged
            );
            return;
        };

        addChatPostToList(
            props?.API,
            corporationId,
            post,
            chatPostAllList,
            setChatPostAllList,
            fileUploadedList,
            setFileUploadedList,
            isDataChanged,
            setIsDataChanged,
            userDetail,
            userChatList,
            setUserChatList
        );
    }, [chatPostUpdate]);

    useEffect(() => {
        if (Utils.isEmptyObject(chatPostInsertFail)) {
            return;
        }
        // updateStatusChatPostInsert(chatPostInsertFail);

        setIsOpenDialogSendChatPostFail(true);
    }, [chatPostInsertFail]);

    return (
        <div className="mainWrap">
            <LoadingPanel isLoading={isLoading} />
            <div className="mainTop mainTop--chat" data-cy="chat-thread-frame">
                <div className="col2">
                    <TabsThreadChat
                        {...args}
                        isBack={true}
                        customerReferenceThread={customerReferenceThread}
                        customerThread={customerThread}
                        internalThread={internalThread}
                        escalationThread={escalationThread}
                        delegateThread={delegateThread}
                        setTicketInfo={setTicketInfo}
                        setSelectThread={setSelectThread}
                        userDetail={userDetail}
                        setIsLoading={setIsLoading}
                        ticketOriginInfor={ticketOriginInfor}
                        isTargetProjectOfTicket={isTargetProjectOfTicket}
                        setIsTargetProjectOfTicket={setIsTargetProjectOfTicket}
                        setReload={setReload}
                        reload ={reload}
                        API={props?.API}
                        isAtTicketDetail={true}
                        fileUploading={fileUploading}
                        setFileUploading={setFileUploading}
                        isProjectManager={isProjectManager}
                        selectThread={selectThread}
                    />
                </div>
            </div>
            <div className="mainFlex">
                <div className="col2">
                    <Chat
                        key={selectThread?.id}
                        selectThread={selectThread}
                        API={props?.API}
                        isShowHeadlineButtonGroup={
                            !Utils.isEmptyObject(internalThread) ||
                            (escalationThread && escalationThread.length > 0) ||
                            !Utils.isEmptyObject(customerReferenceThread) ||
                            (userDetail.userType !== Constant.USER_TYPE.CUSTOMER &&
                                !Utils.isEmptyObject(delegateThread))
                        }
                        isDataChanged={isDataChanged}
                        history={props.history}
                        ticketIdSelected={ticketIdSelected}
                        panelId={props.panelId}
                        panelType={props.panelType}
                        {...args}
                        isOpenModalReloadPage={isOpenModalReloadPage}
                        setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                        formDetail={formDetail}
                        ticketOriginInfor={ticketOriginInfor}
                        formTargetDetail={formTargetDetail}
                        focusedMsgId={focusedMsgId}
                        setFocusedMsgId={setFocusedMsgId}
                        scrollResetKey={scrollResetKey}
                    />
                </div>
            </div>
            <ErrorModal
                open={isModalUploadFileError}
                message={`${fileUploading?.file?.name} ${trI18n('USER04MSG004')}`}
                handleCloseDialog={() => setIsModalUploadFileError(false)}
                title={'Upload fail'}
            ></ErrorModal>
            <DialogSendChatPostFail 
                isOpenDialogSendChatPostFail={isOpenDialogSendChatPostFail} 
                setIsOpenDialogSendChatPostFail={setIsOpenDialogSendChatPostFail}
                {...args}
            />

            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
        </div>
    );
}
